/*eslint-disable*/
export const newFeaturesConfig = {
    en: [
        { 
            date: 20230221, 
            value: '<li><strong>Support</strong> is our new service request and trouble ticket viewing feature. With the ability to track information directly on our website and the option to download an Excel file, we offer a more convenient and streamlined experience. You can now monitor the status of your requests and tickets in real time, receive updates and access information on the go.</li>'
            
        }, 
        { 
            date: 20220222, 
            value: '<li>We want to give you more autonomy and that is why Cloudglass gains a new approach to Manage Services. You can access your cloud services through the Cloud menu</li>'
            
        }, 
        { 
            date: 20201028, 
            value: '<li>We had remove Logs Operation information. Check out our new <a href="https://app.cloudglass.es/#/infrastructure/resources">Resource view</a> in Cloud Resource</li>' 
            
        }, 
        {
            date: 20200213,
            value: '<li>Check out our new <a href="https://app.cloudglass.es/#/reports/spending-breakdown">Breakdown view</a> in Cloud Billing</li>'
        },
        {
            date: 20190726,
            value: '<li>We have added a new tool <a href="https://app.cloudglass.es/#/reports/resume">Explorer</a> that will allow you to explore and understand your consumptions in a much clearer way.</li>' +
            '<li>If you have managed services within Equinix Spain you will be able to access different reports and you will have access to the rest of the portals from <a href="https://app.cloudglass.es/#/reports/external-portals/">Managed Services</a></li>'
        },
        {
            date: 20190430,
            value:
                '<li>Select the account on which you want to perform the service discovery process</li>'
        },
        {
            date: 20190409,
            value:
            '<li>Now you can check when was the last time that your account\'s totals were updated. Just <a href="https://app.cloudglass.es/#/my/dashboard">go to the dashboard</a> and click the link <b>show details</b> at the right side of the chart</li>'
        },
        {
            date: 20190320,
            value:
            '<li>Now you can create multiple alerts at once. Just select one or more accounts, vendors or projects, set the mode that you want to use (sum or multiple) and that\'s all.<br/><a href="https://app.cloudglass.es/#/billing-alerts/alerts">Click here to see it</a></li>'

        },
        {
            date: 20190218,
            value:
        '<li>When you create or edit your accounts, now you can add security credentials for that account in the same place</li>' +
        '<li>We’ve added support for performing service discovery process on your Google Cloud Accounts. To enable this feature you only need to add your security <a target="_blank" href="https://app.cloudglass.es/#/my/credentials">credentials</a></li>' +
        '<li>To improve your customer experience we’ve added Google Analytics. <br> This will help us to focus on how the tools it\'s being used and create better solutions for you. In compliance with EU General Data Protection Regulation (GDPR) you can opt out by going to your  <a href="https://app.cloudglass.es/#/my/profile">profile</a> and click on “Manage cookies permissions” and disable google analytics cookies</li>'

        }
    ],
    es: [
        { 
            date: 20230221, 
            value: '<li><strong>Soporte</strong> es nuestra nueva función de visualización de tickets de solicitud de servicios e incidencias. Con la posibilidad de hacer un seguimiento de la información directamente en nuestro sitio web y la opción de descargar un archivo Excel, ofrecemos una experiencia más cómoda y ágil. Ahora puede supervisar el estado de sus solicitudes y tickets en tiempo real, recibir actualizaciones y acceder a la información sobre la marcha.</li>'      
        }, 
        { 
            date: 20220222, 
            value: '<li>Queremos darte cada vez más autonomía y por eso Cloudglass gana un nuevo enfoque a Managed Services. Puedes acceder a los servicios en la nube a través del menú Cloud</li>'      
        }, 
        { 
            date: 20201028,  
            value: '<li>Hemos borrado las informaciones de Logs de Operaciones. Echa un vistazo a nuestra nueva <a href="https://app.cloudglass.es/#/infrastructure/resources">vista de Recursos</a> en Recursos Cloud</li>'   
        }, 
        {
            date: 20200213,
            value: '<li>Echa un vistazo a nuestra nueva <a href="https://app.cloudglass.es/#/reports/spending-breakdown">vista de Desglose</a> en Facturación Cloud</li>'
        },
        {
            date: 20190726,
            value: '<li>Hemos agregado una nueva herramienta <a href="https://app.cloudglass.es/#/reports/resume">Explorer</a> que te permitirá explorar y comprender tus consumos de una forma mucha mas clara</li>' +
            '<li>Si tienes servicios gestionados dentro de Equinix España podrás acceder a diferentes reportes y tendras acceso al resto de los portales desde <a href="https://app.cloudglass.es/#/reports/external-portals/">Managed Services</a></li>'
        },
        {
            date: 20190430,
            value:
                '<li>Ahora puedes seleccionar las cuentas sobre las que quieres iniciar el proceso para la detección de nuevos recursos.</li>'
        },
        {
            date: 20190409,
            value:
            '<li>Ahora puedes comprobar cuándo fue la última vez que se actualizaron los totales de tu cuenta. Sólo tienes que <a href="https://app.cloudglass.es/#/my/dashboard">Ir al Dashboard</a> y hacer clic en el enlace <b>Mostrar detalles</b> situado en el lado derecho del gráfico.</li>'
        },
        {
            date: 20190320,
            value:
            '<li>Ahora puedes crear múltiples alertas con un click. Solo selecciona una o más cuentas, proveedores o proyectos, selecciona el modo (sum o múltiple) y listo.<br/><a href="https://app.cloudglass.es/#/billing-alerts/alerts">Haz click aquí</a></li>'

        }
    ]
};
/*eslint-enable*/



// WEBPACK FOOTER //
// ./src/config/newFeatures.js